import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { getMeasurements } from '@/api/apiService'
import { QueryKeys } from '../models/enum'
import { ResponseObject, OmniaTimeSeriesDto } from '../models/types'

export function useGetMeasurements(
    plant: string,
    tag: string,
    enabled = true
): UseQueryResult<OmniaTimeSeriesDto[], AxiosError<ResponseObject>> {
    return useQuery({
        queryKey: [QueryKeys.Measurements, plant, tag],
        queryFn: () => getMeasurements(plant, tag),
        enabled: enabled && plant !== '',
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    })
}
